import React, { useEffect, useCallback } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axiosInstance from '../../lib/axios';

const Auth = () => {
    
    const {method} = useParams();
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();

    const code = searchParams.get('code')

    const handleGoogleSignin = useCallback(async () => {
        const response = await axiosInstance.post(`/auth/${method}/signin`, { code: code });

        if (response.status === 200) {
            const responseData = response.data;
            const accessToken = responseData?.access_token;

            localStorage.setItem("token", accessToken);
            navigate("/");
        }
    }, [code, method, navigate]);

    useEffect(() => {
        handleGoogleSignin();
    }, [handleGoogleSignin]);
    return (
        <div>logging you in, Please Wait!!!</div>
    )
};

export default Auth;